import { Row, Col } from 'react-bootstrap'
import './App.css';
import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect'
import { Slideshow } from './SlideShow';
import MobileApp from './MobileApp';

const SCROLL_OFFSETS = {
  INTRO: 500,
  EDUCATION: 900,
  COURSES: 1100,
  EXPERIENCE_START: 2100,
  EXPERIENCE_GAP: 700,
  SKILLS_START: 4350,
  CONTACT: 5950,
  SAKURA_BG: {
    START: 4250,
    END: 5650,
    TRANSFORM_BASE: 3950
  },
  SAKURA3: {
    START: 1800,
    TRANSFORM_BASE: 2750
  }
};

const EXPERIENCE_STYLES = {
  TITLE: {
    fontSize: '3em',
    width: 600,
  },
  DATE: {
    fontSize: '0.9em',
    width: 600,
    opacity: 0.6
  },
  DESCRIPTION: {
    fontSize: '1.2em',
    width: 600,
  }
};

const getRelativeScroll = (scrollPosition, basePoint, offset = 0) => {
  return scrollPosition - (basePoint + offset);
};

const getOpacity = (relativeScroll, fadeStart = 0, duration = 250) => {
  return Math.min(Math.max((relativeScroll - fadeStart) / duration, 0), 1);
};

// Smooths the discrete scroll-driven style updates so elements glide
// between frames instead of stepping with each scroll event
const SMOOTH = {
  transition: 'transform 0.2s ease-out, opacity 0.2s ease-out',
  willChange: 'transform, opacity'
};

// For scroll-staggered fades where the element must not drift with the
// scroll (the sticky skills block): only opacity is transitioned
const SMOOTH_OPACITY = {
  transition: 'opacity 0.2s ease-out',
  willChange: 'transform, opacity'
};

function App() {
  const [scrollPosition, setScrollPosition] = useState(0);

  var link = <a href="https://datascience.hiqsyd.se/" target="_blank" rel="noopener noreferrer">website</a>;

  useEffect(() => {
    // Sync scroll-driven animation updates to the browser frame rate
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setScrollPosition(window.pageYOffset);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const getExperienceOpacity = (index) => {
    return getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.EXPERIENCE_START, index * SCROLL_OFFSETS.EXPERIENCE_GAP));
  };

  const getExperienceTransform = (index, direction) => {
    const relativeScroll = getRelativeScroll(scrollPosition, SCROLL_OFFSETS.EXPERIENCE_START, index * SCROLL_OFFSETS.EXPERIENCE_GAP + 250);
    const shift = direction === 'left' ? 20 : -30;
    return `translate(${shift + Math.min(relativeScroll, -50) / 10}%,0%)`;
  };

  if (isMobile || window.innerWidth < 768) {
    return <MobileApp />;
  }

  return (
    <div style={{
      height: "1250px",
      width: "100%",
      background: `linear-gradient(pink, #FFFFFF 75%`
    }}>
      {window.innerWidth < 1440 ? <p style={{ position: 'absolute', top: scrollPosition }}>For best experience, use a screen wider than 1440px</p> : <></>}

      <Row>
        <img src={require('./sakura4.png')} alt="sakura4" className='fade-in-soft' style={{ position: 'absolute', transform: `translate(70%,0%)`, width: 750 }}></img>
      </Row>

      <div style={{ textAlign: 'center', height: "200px" }}></div>

      <Row>
        <Col>
          <p className='signature fade-in-load'>Yi Wang</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className='sub-signature fade-in-load delay-1'>Software Developer</p>
        </Col>
      </Row>

      <div style={{ textAlign: 'center', height: "500px" }}></div>

      <Row>
        <Col>
          <p style={{ ...SMOOTH, textAlign: 'center', opacity: 0.2, transform: `translate(${Math.min(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.INTRO) / 10, 0)}%,0%)` }} className='sub-signature'>INTRODUCTION</p>
        </Col>
        <Col>
          <p className='title-text'>Software developer with data analysis skills.</p>
        </Col>
        <Col></Col>
      </Row>

      <Row>
        <Col>
          <p className='title-text'>Strives to use data to improve the user experience by finding the most optimal way to guide the user's eyes.</p>
        </Col>
      </Row>
      <div style={{ height: "200px" }}></div>

      <Row>
        <Col></Col>
        <Col>
          <p className='title-text'>MSc in Data Analytics and Business Economics at Lund University</p>
        </Col>
        <Col>
          <p style={{ ...SMOOTH, textAlign: 'center', opacity: 0.2, transform: `translate(${-Math.min(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.EDUCATION) / 10, 10)}%,0%)` }} className='sub-signature'>EDUCATION</p>
        </Col>
      </Row>
      <div style={{ height: "200px" }}></div>

      <Row>
        <Col>
          <p style={{ textAlign: 'center' }} className='sub-signature'>COURSES</p>
        </Col>
      </Row>
      <div style={{ height: "20px" }}></div>
      <Row>
        <a href="https://mau.se/en/study-education/courses/da204e/" rel="noopener noreferrer" target="_blank" className='title-text' style={{ ...SMOOTH, opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.COURSES, 75)) }}>Programming in C# - Malmö University</a>
      </Row>
      <div style={{ height: "50px" }}></div>
      <Row>
        <a href="https://www.udemy.com/course/javascript-beginners-complete-tutorial/?srsltid=AfmBOoq2h1B4KgS8euLx8rslWD7mIuI-uZub1LC5OweH0rx_R00w9zBV" target="_blank" rel="noopener noreferrer" className='title-text' style={{ ...SMOOTH, opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.COURSES)) }}>The Modern Javascript Bootcamp Course</a>
      </Row>
      <div style={{ height: "50px" }}></div>
      <Row>
        <a href="https://www.udemy.com/course/react-redux/" target="_blank" rel="noopener noreferrer" className='title-text' style={{ ...SMOOTH, opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.COURSES)) }}>Modern React with Redux</a>
      </Row>
      <div style={{ height: "50px" }}></div>
      <Row>
        <a href="https://www.udemy.com/course/python-for-data-science-and-machine-learning-bootcamp/" target="_blank" rel="noopener noreferrer" className='title-text' style={{ ...SMOOTH, opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.COURSES, 150)) }}>Python for Data Science and Machine Learning Bootcamp</a>
        {scrollPosition > SCROLL_OFFSETS.SAKURA3.START ? (
          <img 
            alt="sakura3" 
            src={require('./sakura3.png')} 
            style={{
              ...SMOOTH,
              position: 'absolute',
              transform: `translate(0%,${Math.min(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SAKURA3.TRANSFORM_BASE), 0) / 10 + 60}%)`,
              width: 500,
              opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SAKURA3.START), 0, 200)
            }}
          />
        ) : <></>}
      </Row>
      <div style={{ height: "200px" }}></div>

      <Row>
        <p className="sub-signature" style={{ ...SMOOTH, opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.EXPERIENCE_START), -200) }}>EXPERIENCE</p>
      </Row>
      <div style={{ height: "80px" }}></div>

      {/* Front end developer */}
      <Row>
        <Col style={{ ...SMOOTH, width: 600, height: 600, opacity: getExperienceOpacity(0), transform: getExperienceTransform(0, 'left') }}>
          <div style={{ height: "20px" }}></div>
          <Row>
            <p className="sub-signature" style={EXPERIENCE_STYLES.TITLE}>Software Developer</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DATE}>Playtech</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DATE}>October 2023 — Present</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Developed and customized frontend features for white-label sports betting platforms using React Redux, JavaScript (ES6+), HTML5, and CSS3.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Implemented responsive components and improved cross-browser compatibility for desktop and mobile devices.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Collaborated with different teams to integrate APIs and enhance platform stability.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Optimized component reusability through modular architecture and best practices.</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>Tech Stack & Tools: React Redux, JavaScript, HTML5, CSS3, REST APIs, Webpack, Git, Agile, Docker (basic understanding)</p>
          </Row>
        </Col>
        <Col style={{ ...SMOOTH, width: 600, height: 600, opacity: getExperienceOpacity(0), transform: getExperienceTransform(0, 'right') }}>
          <Slideshow 
            images={[
              require('./playtech1.jpg'),
              require('./playtech2.jpg'),
              require('./playtech3.jpg')
            ]} 
            width={600}
            height={600}
          />
        </Col>
      </Row>

      <div style={{ height: "150px" }}></div>

      {/* Front end assistant */}
      <Row>
        <Col style={{ ...SMOOTH, width: 600, height: 600, opacity: getExperienceOpacity(1), transform: getExperienceTransform(1, 'left') }}>
          <div style={{ height: "20px" }}></div>
          <Row>
            <p className="sub-signature" style={EXPERIENCE_STYLES.TITLE}>Frontend Assistant</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DATE}>HiQ</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DATE}>July 2023 — August 2023</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Developed and maintained a data visualization {link} for electricity price predictions using React.js and modern web technologies.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Collaborated with UX designers using Figma to implement intuitive and responsive user interfaces.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Optimized data visualization components for real-time updates and improved user experience.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Implemented responsive design principles ensuring compatibility across all devices.</p>
          </Row>
        </Col>
        <Col style={{ ...SMOOTH, width: 600, height: 600, opacity: getExperienceOpacity(1), transform: getExperienceTransform(1, 'right') }} >
          <img src={require('./elspargif.gif')} style={{ position:'absolute', width: 600, height:600, left: 400 }} alt="elspargif" />
        </Col>
      </Row>

      <div style={{ height: "150px" }}></div>

      {/* AI iOS developer */}
      <Row>
        <Col style={{ ...SMOOTH, width: 600, height: 600, opacity: getExperienceOpacity(2), transform: getExperienceTransform(2, 'left') }}>
          <div style={{ height: "20px" }}></div>
          <Row>
            <p className="sub-signature" style={EXPERIENCE_STYLES.TITLE}>AI IOS Developer</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DATE}>Hobby Project</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DATE}>2026</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Developed with the help of Claude Code in Visual Studio Code.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• A personal period-tracking app that predicts upcoming cycles, logs daily symptoms (cramps, mood, pain levels, notes), and visualizes cycle trends over time.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Home-screen widget for quick period logging and countdown to the next expected period, plus automatic reminder notifications before and during predicted periods.</p>
          </Row>
          <div style={{ height: "15px" }}></div>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>• Data backup/export, light/dark themes, and support for both English and Chinese.</p>
          </Row>
          <Row>
            <p className='title-text' style={EXPERIENCE_STYLES.DESCRIPTION}>Tech Stack & Tools: Swift, SwiftUI, iOS Widgets, XCode, Git.</p>
          </Row>
        </Col>
        <Col style={{ ...SMOOTH, width: 600, height: 600, opacity: getExperienceOpacity(2), transform: getExperienceTransform(2, 'right') }}>
          <Slideshow
            images={[
              require('./periodtracker1.jpg'),
              require('./periodtracker2.jpg'),
              require('./periodtracker3.jpg'),
              require('./periodtracker4.jpg')
            ]}
            width={600}
            height={600}
          />
        </Col>
      </Row>

      {/* Skills — position: sticky pins the block natively (zero scroll lag);
          the runway height controls how long it stays pinned. Its height is
          coupled with the 425px spacer below: together they must stay 2625px
          so the CONTACT/sakura offsets keep working. */}
      <div style={{ height: "2200px" }}>
        <div style={{ position: 'sticky', top: '8vh', zIndex: 1 }}>
          <Row>
            <p className="sub-signature" style={{ ...SMOOTH_OPACITY, lineHeight: '1.3', opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SKILLS_START, 300)) }} >SKILLS</p>
          </Row>
          <div style={{ height: "20px" }}></div>
          {[
            { name: 'Javascript', level: '****' },
            { name: 'React.js', level: '****' },
            { name: 'HTML/CSS', level: '****' },
            { name: '.NET C#', level: '***' },
            { name: 'Node.js', level: '***' },
            { name: 'Python', level: '***' },
            { name: 'R', level: '**' },
            { name: 'AWS', level: '**' },
            { name: 'Azure', level: '**' }
          ].map((skill, index) => (
            <Row key={skill.name}>
              <Col></Col>
              <Col>
                <p className='title-text' style={{
                  ...SMOOTH_OPACITY,
                  lineHeight: '1.3',
                  opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SKILLS_START, 300 + index * 125))
                }}>{skill.name}</p>
              </Col>
              <Col>
                <p className='sub-signature' style={{
                  ...SMOOTH_OPACITY,
                  lineHeight: '1.3',
                  opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SKILLS_START, 300 + index * 125))
                }}>{skill.level}</p>
              </Col>
              <Col></Col>
            </Row>
          ))}
          <Row>
            <p className='title-text' style={{
              ...SMOOTH_OPACITY,
              opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SKILLS_START, 1300))
            }}>And loves to learn more!</p>
          </Row>
        </div>
      </div>

      <Row>
        {scrollPosition > SCROLL_OFFSETS.SAKURA_BG.START && scrollPosition < SCROLL_OFFSETS.SAKURA_BG.END ? (
          <img 
            alt="sakura7" 
            src={require('./sakura7.png')} 
            style={{
              ...SMOOTH,
              position: 'absolute',
              zIndex: -1,
              opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SAKURA_BG.START)),
              transform: `translate(5%, calc(${Math.min(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.SAKURA_BG.TRANSFORM_BASE), 3000) * 0.15 - 200}% - 1275px))`,
              width: 1600,
              height: 1600
            }}
          />
        ) : <div></div>}
        <img alt="sakura1" src={require('./sakura1.png')} style={{ position: 'absolute', transform: `translate(0%, calc(100% - 1275px))`, width: 750, opacity: 1 }}></img>
      </Row>

      <div style={{ height: "425px" }}></div>
      <div style={{
        height: "570px",
        background: `linear-gradient( #FFFFFF 30%,pink)`
      }}>
        <div style={{ ...SMOOTH, opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.CONTACT)) }}>
          <Row>
            <p className="sub-signature">Contact Me</p>
          </Row>
          <div style={{ height: "50px" }}></div>
          <Row>
            <Col>
              <a href="https://www.linkedin.com/in/yi-wang-9349b524b/" target="_blank" rel="noopener noreferrer">
                <img src={require('./LinkedIn_logo.png')} style={{ opacity: getOpacity(getRelativeScroll(scrollPosition, SCROLL_OFFSETS.EXPERIENCE_START)), background: 'linear-gradient( #FFFFFF 20%,darkblue 1500%)', borderRadius: 200, width: 200, height: 200 }} alt="portrait" />
              </a>
            </Col>
          </Row>
          <div style={{ height: "50px" }}></div>
          <Row>
            <Col>
              <p className="sub-signature">jacquie.y.wang@gmail.com</p>
            </Col>
          </Row>
        </div>
        <div style={{ height: "50px" }}></div>
      </div>
    </div>
  );
}

export default App;